export default __webpack_public_path__ + "static/media/JO.1cd6753e.svg";